import type { OpenOSContext } from "ic-analytics";
import { connectToParent } from "penpal";

interface OSApi {
    getAccessToken: () => Promise<string>;
}

/**
 * @param setWppProjectId - Callback to set project ID
 */
export async function getWppToken(
    setWppProjectId?: (projectId: string) => void,
    setWppTenantId?: (tenantId: string) => void,
    setWppWorkspaceId?: (workspaceId: string) => void,
    setWppDevhubAppVersionId?: (devhubAppVersionId: string) => void
) {
    const connection = connectToParent<{ osApi: OSApi }>({
        timeout: 1500,
        methods: {
            receiveOsContext: (osContext: OpenOSContext) => {
                if (setWppProjectId && osContext?.project?.id) {
                    setWppProjectId(osContext.project.id);
                }
                if (setWppTenantId && osContext?.tenant?.id) {
                    setWppTenantId(osContext.tenant.id);
                }
                if (setWppWorkspaceId && osContext?.additional?.workspaceId) {
                    setWppWorkspaceId(osContext.additional.workspaceId as string);
                }
                if (setWppDevhubAppVersionId && osContext?.appInstance?.devhubAppVersionId) {
                    setWppDevhubAppVersionId(osContext.appInstance.devhubAppVersionId);
                }
            }
        }
    });

    const { osApi } = await connection.promise;

    return osApi.getAccessToken();
}

/**
 * @param setWppProjectId - Callback to set project ID
 * @param onContextReceived - Callback to handle full context
 */
export async function getWppTokenAndContext(
    setWppProjectId: (projectId: string) => void,
    onContextReceived: (osContext: OpenOSContext) => void,
    setWppTenantId: (tenantId: string) => void,
    setWppWorkspaceId: (workspaceId: string) => void,
    setWppDevhubAppVersionId?: (devhubAppVersionId: string) => void
) {
    const connection = connectToParent<{ osApi: OSApi }>({
        timeout: 1500,
        methods: {
            receiveOsContext: (osContext: OpenOSContext) => {
                if (setWppProjectId && osContext?.project?.id) {
                    setWppProjectId(osContext.project.id);
                }

                if (onContextReceived && typeof onContextReceived === "function") {
                    onContextReceived(osContext);
                }
                if (setWppTenantId && osContext?.tenant?.id) {
                    setWppTenantId(osContext.tenant.id);
                }
                if (setWppWorkspaceId && osContext?.additional?.workspaceId) {
                    setWppWorkspaceId(osContext.additional.workspaceId as string);
                }
                if (setWppDevhubAppVersionId && osContext?.appInstance?.devhubAppVersionId) {
                    setWppDevhubAppVersionId(osContext.appInstance.devhubAppVersionId);
                }
            }
        }
    });

    try {
        const { osApi } = await connection.promise;

        return osApi.getAccessToken();
    } catch (error) {
        console.error("Failed to get WPP token and context:", error);
        throw error;
    }
}
